export default {
    instantPackageId: {
        presence: true,
        type: "string",
    },
    customerId: {
        type: "string",
    },
};
